<template>
  <div id="scheduleDetail_localData">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="localDataProp && !localDataProp.isHasData"
    />
    <template v-else>
      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_6_19'
        "
      >
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
          :sportCompetitionType="sportCompetitionType"
        ></EVENTCOP_MODE_6>

        <EVENTCOP_MODE_19
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :tabType="localDataProp.type"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_19>
      </template>
      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_6 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_6.vue'
import EVENTCOP_MODE_19 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_19.vue'
export default {
  name: 'scheduleDetail_localData',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_6,
    EVENTCOP_MODE_19,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
      }),
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('localData 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          // if (!newVal.isHasData) {
          //   this.eventCompModeDatas = {}
          // } else if (JSON.stringify(newVal.datas) !== JSON.stringify(newVal.datas)) {
          //   this.eventCompModeDatas = JSON.parse(JSON.stringify(newVal.datas))
          // }
          // if (
          //   newVal.eventCompMode === 'complexTypeMode_6_7_5' &&
          //   newVal.datas &&
          //   newVal.datas.athleteStats &&
          //   newVal.datas.athleteStats.annotation
          // ) {
          //   let datas = newVal.datas
          //   datas.annotation = newVal.datas.athleteStats.annotation
          //   this.eventCompModeDatas = JSON.parse(
          //     JSON.stringify(datas ? datas : {})
          //   )
          // } else if (
          //   ['SAL', 'WSU', 'ROL', 'EQU'].includes(
          //     this.currSportsDetail.sportsId
          //   ) &&
          //   newVal.eventCompMode === 'mode_24' &&
          //   newVal.datas &&
          //   newVal.datas['result_single']
          // ) {
          //   let datas = newVal.datas['result_single']
          //   datas.annotation = datas.annotation ? datas.annotation : []
          //   this.eventCompModeDatas = JSON.parse(
          //     JSON.stringify(datas ? datas : {})
          //   )
          // } else {
          //   this.eventCompModeDatas = JSON.parse(
          //     JSON.stringify(newVal.datas ? newVal.datas : {})
          //   )
          // }
          this.eventCompModeDatas = JSON.parse(
            JSON.stringify(newVal.datas ? newVal.datas : {})
          )
          console.debug('this.eventCompModeDatas:', this.eventCompModeDatas)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // eventCompMode: 'mode_2',
      eventCompModeDatas: null,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // window.scrollTo(0, Math.floor(30.776 * this.vw2px))
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#scheduleDetail_localData {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
